import React, { useEffect, useRef, useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import BestFacilities from '../../components/shared/BestFacilities';
import ProductsFilterOptions from '../../components/products/ProductsFilterOptions';
import ProductsGridTypeOne from '../../components/products/ProductsGridTypeOne';
import { SiteLeftSidebarFilter } from '../../components/shared/SiteLeftSidebarFilter';
import SitePagination from '../../components/shared/SitePagination';

import SubscribeNewsLetter from '../../components/shared/SubscribeNewsLetter';
import { MakeApiCallSynchronous, MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import Config from '../../../helpers/Config';
import { useSelector, useDispatch } from 'react-redux';
import rootAction from '../../../stateManagment/actions/rootAction';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { Helmet } from 'react-helmet';
import GlobalEnums from '../../../helpers/GlobalEnums';
import { GetLocalizationControlsJsonDataForScreen, replaceLoclizationLabel, ScrollIntoSpecificDiv } from '../../../helpers/CommonHelper';
import { filterProductsByDeliveryLocation } from '../../../helpers/LocationHelper';
import '../../components/products/HomeProducts.css';
import './AllProducts.css';
import { normalizeSearchTerm, filterProductsBySearch } from '../../../helpers/ProductSearch';


const AllProducts = () => {
    const dispatch = useDispatch();
    const search = useLocation().search;
    const query = normalizeSearchTerm(new URLSearchParams(search).get('SearchTerm'));
    const resultsRequest = useRef(0);
    const [resultsLoading, setResultsLoading] = useState(true);
    const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);
    const [RowColCssCls, setRowColCssCls] = useState("col-lg-3 col-md-12");
    const [ProductListMainClass, setProductListMainClass] = useState("col-lg-4 col-sm-6 col-md-4 col-6 products-col-item");
    const [gridClass, setGridClass] = useState("products-row-view");
    const [ProductsList, setProductsList] = useState([]);
    const [filterProducts, setFilterProducts] = useState([]);
    const [filtersLoading, setFiltersLoading] = useState(true);
    const [TotalRecords, setTotalRecords] = useState(0);
    const [showPagination, setshowPagination] = useState(false);
    const [PageNo, setPageNo] = useState(1);
    const [PageSize, setPageSize] = useState(100);
    const [OrderByColumnName, setOrderByColumnName] = useState('');
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);
    const [showMobileFilters, setShowMobileFilters] = useState(false);

    //--set product id from url
    const params = useParams();
    const [CategoryID, setCategoryID] = useState(params.category_id ?? 0);


    const [SearchTerm, setSearchTerm] = useState(normalizeSearchTerm(new URLSearchParams(search).get('SearchTerm')));
    const [SizeID, setSizeID] = useState(null);
    const [ColorID, setColorID] = useState(null);
    const [TagID, setTagID] = useState(null);
    const [ManufacturerID, setManufacturerID] = useState(null);
    const [MinPrice, setMinPrice] = useState(null);
    const [MaxPrice, setMaxPrice] = useState(null);
    const [Rating, setRating] = useState(null);



    useEffect(() => {
        let mounted = true;
        setFiltersLoading(true);
        setFilterProducts([]);
        const load = async () => {
            const products = [];
            const pageSize = 200;
            for (let pageNo = 1; mounted; pageNo += 1) {
                const response = await MakeApiCallAsync(Config.END_POINT_NAMES.GET_All_PRODUCTS, null,
                    {requestParameters: {SearchTerm: normalizeSearchTerm(new URLSearchParams(search).get('SearchTerm')), CategoryID: CategoryID, PageNo: pageNo, PageSize: pageSize, recordValueJson: '[]'}},
                    {Accept: 'application/json', 'Content-Type': 'application/json'}, 'POST', true);
                if (!response?.data?.data) throw new Error('Unable to load related filters');
                const page = JSON.parse(response.data.data);
                products.push(...filterProductsBySearch(filterProductsByDeliveryLocation(page), query));
                const total = Number(page[0]?.TotalRecords);
                if (page.length < pageSize || (total > 0 && pageNo * pageSize >= total)) break;
            }
            if (mounted) setFilterProducts(products);
        };
        load().catch(console.error).finally(() => { if (mounted) setFiltersLoading(false); });
        return () => { mounted = false; };
    }, [search, CategoryID]);

    const handleGrid = (e) => {

        setGridClass(e);

    }


    const setFilterValueInParent = async (e, value, type) => {

        e.preventDefault();

        if (type == "category") {
            await setCategoryID(value);
            await getAllProductsAfterAnyFilterChange(1, value, null, null, null, null, null, null, null, null);

        } else if (type == "brand") {
            await setManufacturerID(value);
            await getAllProductsAfterAnyFilterChange(1, null, value, null, null, null, null, null, null, null);
        } else if (type == "size") {

            await setSizeID(value);
            await getAllProductsAfterAnyFilterChange(1, null, null, value, null, null, null, null, null, null);

        } else if (type == "price") {

            // setTimeout(() => {
            //     const priceArray = value.split("-");
            //     setMinPrice(priceArray[0]);
            //     setMaxPrice(priceArray[1]);
            // }, 100);

            const priceArray = value.split("-");
            await setMinPrice(priceArray[0]);
            await setMaxPrice(priceArray[1]);

            await getAllProductsAfterAnyFilterChange(1, null, null, null, priceArray[0], priceArray[1], null, null, null, null);

        } else if (type == "color") {

            await setColorID(value);
            await getAllProductsAfterAnyFilterChange(1, null, null, null, null, null, null, null, value, null);

        }
        else if (type == "rating") {

            await setRating(value);
            await getAllProductsAfterAnyFilterChange(1, null, null, null, null, null, value, null, null, null);

        } else if (type == "tag") {

            await setTagID(value);
            await getAllProductsAfterAnyFilterChange(1, null, null, null, null, null, null, value, null, null);
        }


    }

    //--this function called from the ProductsFiltersOption component
    const setPageSizeFromProductFilter = async (e) => {

        setPageSize(parseInt(e.target.value));
        await getAllProductsAfterAnyFilterChange(1, null, null, null, null, null, null, null, null, null);

    }

    const setSortByFilter = async (e) => {

        setOrderByColumnName(parseInt(e.target.value));
        await getAllProductsAfterAnyFilterChange(1, null, null, null, null, null, null, null, null, e.target.value);

    }

    //--this function called from the SitePagination component
    const setCurrentPage = async (pageNumber) => {


        setTimeout(async () => {
            await getAllProductsAfterAnyFilterChange(pageNumber, null, null, null, null, null, null, null, null, null);
        }, 200);



    }

    const getAllProductsAfterAnyFilterChange = async (pageNumber, _categoryId, _manufacturerId, _sizeId,
        _minPrice, _maxPrice, _rating, _tagId, _colorId, _orderByColumnName) => {


        const requestId = ++resultsRequest.current;
        setResultsLoading(true);
        try {



            //--start loader
            dispatch(rootAction.commonAction.setLoading(true));

            await setPageNo(pageNumber);

            let headersFromPage = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }


            let paramFromPage = {
                requestParameters: {
                    SearchTerm: query,
                    SizeID: _sizeId ?? SizeID,
                    ColorID: _colorId ?? ColorID,
                    CategoryID: _categoryId ?? CategoryID,
                    TagID: _tagId ?? TagID,
                    ManufacturerID: _manufacturerId ?? ManufacturerID,
                    MinPrice: _minPrice ?? MinPrice,
                    MaxPrice: _maxPrice ?? MaxPrice,
                    Rating: _rating ?? Rating,
                    OrderByColumnName: _orderByColumnName ?? OrderByColumnName,
                    PageNo: pageNumber ?? PageNo,
                    PageSize: PageSize,
                    recordValueJson: "[]",
                },
            };

            setshowPagination(false);


            let responseAllProducts = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_All_PRODUCTS'], null, paramFromPage, headersFromPage, "POST", true);
            if (requestId !== resultsRequest.current) return;
            if (responseAllProducts != null && responseAllProducts.data != null) {

                let AllProducts = JSON.parse(responseAllProducts.data.data);
                const filteredProducts = filterProductsBySearch(filterProductsByDeliveryLocation(AllProducts), query);
                await setProductsList(filteredProducts);
                await setTotalRecords(filteredProducts.length)
                console.log(JSON.parse(responseAllProducts.data.data));

                if (filteredProducts.length > 0) {
                    await setshowPagination(true);
                }

            }


            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);

            //--Scroll to main div
            ScrollIntoSpecificDiv("all_products_main_sec", "smooth");

        }
        catch (error) {

            //--stop loader
            setTimeout(() => {
                dispatch(rootAction.commonAction.setLoading(false));
            }, LOADER_DURATION);

        } finally {
            if (requestId === resultsRequest.current) setResultsLoading(false);
        }






    }



    useEffect(() => {

        const requestId = ++resultsRequest.current;
        setProductsList([]);
        setResultsLoading(true);
        const getAllProducts = async () => {
            const routeSearchTerm = normalizeSearchTerm(new URLSearchParams(search).get('SearchTerm'));
            setSearchTerm(routeSearchTerm);
            setCategoryID(params.category_id ?? 0);
            setSizeID(null); setColorID(null); setTagID(null); setManufacturerID(null);
            setMinPrice(null); setMaxPrice(null); setRating(null); setPageNo(1);


            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }


            const param = {
                requestParameters: {
                    SearchTerm: routeSearchTerm,
                    SizeID: null,
                    ColorID: null,
                    CategoryID: params.category_id ?? 0,
                    TagID: null,
                    ManufacturerID: null,
                    MinPrice: null,
                    MaxPrice: null,
                    Rating: null,
                    OrderByColumnName: OrderByColumnName,
                    PageNo: 1,
                    PageSize: PageSize,
                    recordValueJson: "[]",
                },
            };

            setshowPagination(false);


            const response = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_All_PRODUCTS'], null, param, headers, "POST", true);
            if (requestId !== resultsRequest.current) return;
            if (response != null && response.data != null) {

                let AllProducts = JSON.parse(response.data.data);
                const filteredProducts = filterProductsBySearch(filterProductsByDeliveryLocation(AllProducts), query);
                await setProductsList(filteredProducts);
                await setTotalRecords(filteredProducts.length)
                console.log(JSON.parse(response.data.data));

                if (filteredProducts.length > 0) {
                    await setshowPagination(true);
                }

            }


            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["AllProducts"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }


        }

        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));

        // call the function
        getAllProducts().catch(console.error).finally(() => { if (requestId === resultsRequest.current) setResultsLoading(false); });

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);

        return () => { if (requestId === resultsRequest.current) resultsRequest.current += 1; };
    }, [search, params.category_id])

    return (
        <>
            <Helmet>
                <title>{siteTitle} - All Products</title>
                <meta name="description" content={siteTitle + " - All Products"} />
                <meta name="keywords" content="All Products"></meta>
            </Helmet>

            <section className={`products-collections-area all-products-market${showMobileFilters ? ' filters-open' : ''}`} id="all_products_main_sec">
                <div className="container-fluid">
                    <div className="section-title">
                        <h2>
                            <span className="dot"></span><span id="lbl_allprd_allproduct">
                                {query ? `Search results for "${query}"` : LocalizationLabelsArray.length > 0 ?
                                    replaceLoclizationLabel(LocalizationLabelsArray, "All Products", "lbl_allprd_allproduct")
                                    :
                                    "All Products"
                                }
                            </span>
                        </h2>
                    </div>

                    <button type="button" className="all-products-mobile-filter-button" onClick={() => setShowMobileFilters(!showMobileFilters)}>
                        <i className={`fas ${showMobileFilters ? 'fa-times' : 'fa-filter'}`} aria-hidden="true" />
                        {showMobileFilters ? 'Close filters' : 'Filter products'}
                    </button>

                    <div className="row" >


                        <SiteLeftSidebarFilter
                            RowColCssCls={`${RowColCssCls} all-products-filter-column`}
                            setFilterValueInParent={setFilterValueInParent}
                            filterProducts={filterProducts}
                            filtersLoading={filtersLoading}
                            searchTerm={search}
                            routeCategoryId={params.category_id}

                        />

                        <div className="col-lg-9 col-md-12 all-products-market__results">

                            <ProductsFilterOptions
                                onClick={(e) => { handleGrid(e); }}
                                activeView={gridClass}
                                setPageSizeFromProductFilter={setPageSizeFromProductFilter}
                                setSortByFilter={setSortByFilter}
                                PageNo={PageNo}
                                PageSize={PageSize}
                                TotalRecords={ProductsList != undefined && ProductsList.length > 0 && ProductsList[0].TotalRecords != undefined && ProductsList[0].TotalRecords != 0 ? ProductsList[0].TotalRecords : 0}
                            />

                            {resultsLoading && <p role="status">Loading products...</p>}
                            {!resultsLoading && ProductsList.length === 0 && <p role="status">{query ? `No products found for "${query}". Try another product name or keyword.` : 'No products found.'}</p>}
                            <div id="products-filter" className={`products-collections-listing row trending-products-grid all-products-elegant ${gridClass}`}>

                                <ProductsGridTypeOne
                                    ProductsList={ProductsList}
                                    ProductListMainClass={ProductListMainClass}

                                />
                            </div>

                            {
                                showPagination == true ?
                                    <SitePagination
                                        TotalRecords={TotalRecords}
                                        CurrentPage={PageNo}
                                        PageSize={PageSize}
                                        setCurrentPage={setCurrentPage}
                                    />

                                    :
                                    <>
                                    </>
                            }


                        </div>



                    </div>






                </div>
            </section>



            <BestFacilities />
            <SubscribeNewsLetter />

        </>
    );

}

export default AllProducts;


